import { PLACE_ID_PATTERN, RUTERO_HOLD_PASSENGER_MAX } from '@bandido/shared/types';

import type { ToursSearchPayload } from './queries';
import { isSearchDate } from './searchDates';

export function tourPartySizeFromParam(
  value: string | undefined,
): number | undefined {
  if (!value) return undefined;
  const parsed = Number(value);
  return Number.isInteger(parsed) &&
    parsed >= 1 &&
    parsed <= RUTERO_HOLD_PASSENGER_MAX
    ? parsed
    : undefined;
}

/** Deriva el payload exclusivamente del estado confirmado en la URL. */
export function tourSearchPayloadFromParams(
  params: Record<string, string>,
): ToursSearchPayload | null {
  if (params.buscar !== '1' || !params.destino) return null;
  if (params.desde && !isSearchDate(params.desde)) return null;
  if (params.hasta && (!params.desde || !isSearchDate(params.hasta))) return null;
  if (params.desde && params.hasta && params.hasta < params.desde) return null;
  const partySize = tourPartySizeFromParam(params.pax);
  if (params.pax && partySize === undefined) return null;
  if (!PLACE_ID_PATTERN.test(params.destino)) return null;

  return {
    destination: params.destino,
    ...(params.desde ? { from: params.desde } : {}),
    ...(params.hasta ? { to: params.hasta } : {}),
    ...(partySize ? { partySize } : {}),
  };
}
